import { Button, Table, Tag, Timestamp } from '@dixa/lib-shared-habla';
import { typography } from '@dixa/lib-shared-tokens';
import { PlatformApplicationStatus } from 'lib-shared-legacy-types';

import { TableLoadingRow } from 'components/shared/tableLoadingRow';
import { usePlatformApplications } from 'hooks/usePlatformApplications';

import { mapPlatform } from '../../platforms';

import { ActionMenu } from './components/actionMenu/actionMenu';
import styles from './listPlatformsBody.module.scss';

const columnCount = 4;

type Props = ReturnType<typeof usePlatformApplications> & {
  showUpdateModal: (platformId: string) => void;
  showDeleteModal: (platformId: string) => void;
};

export function ListPlatformsBody(props: Props): JSX.Element {
  const { items, asyncStatus } = props;

  if (asyncStatus !== 'succeeded') {
    return <LoadingRow {...props} />;
  }

  if (items.length === 0) {
    return (
      <Table.Tr>
        <Table.Td colSpan={columnCount}>
          No push notification platforms found.
        </Table.Td>
      </Table.Tr>
    );
  }

  return (
    <>
      {items.map((x) => (
        <Table.Tr key={x.id}>
          <Table.Td className={styles.columnPlatformText}>
            {mapPlatform(x.platform)}
          </Table.Td>
          <Table.Td>
            <PlatformStatus status={x.status} />
          </Table.Td>
          <Table.Td>
            {x.updated_at ? <Timestamp relative time={x.updated_at} /> : '-'}
          </Table.Td>
          <Table.Td align="right">
            <ActionMenu
              platformId={x.id}
              onUpdate={props.showUpdateModal}
              onDelete={props.showDeleteModal}
            />
          </Table.Td>
        </Table.Tr>
      ))}
    </>
  );
}

function LoadingRow(props: Props): JSX.Element {
  const { asyncStatus, refreshItems } = props;

  if (asyncStatus === 'failed') {
    return (
      <Table.Tr>
        <Table.Td colSpan={columnCount}>
          Something went wrong...
          <Button variant="tertiary" onClick={refreshItems}>
            Try again
          </Button>
        </Table.Td>
      </Table.Tr>
    );
  }

  return <TableLoadingRow colSpan={columnCount} />;
}

function PlatformStatus({
  status,
}: {
  status: PlatformApplicationStatus;
}): JSX.Element {
  switch (status) {
    case 'ACTIVE':
      return <Tag color={typography.color.success}>Active</Tag>;
    case 'PROVISIONING':
      return <Tag color={typography.color.warning}>Provisioning</Tag>;
    case 'DELETING':
      return <Tag color={typography.color.error}>Deleting</Tag>;
    case 'ERROR':
      return <Tag color={typography.color.error}>Error</Tag>;
  }
}
